let isFetchInterceptorInitialized = false;

const initializeFetchInterceptor = () => {
  if (isFetchInterceptorInitialized) {
    return;
  }

  isFetchInterceptorInitialized = true;

  const originalFetch = window.fetch;

  window.fetch = async (...args) => {
    const requestUrl = args[0];

    try {
      const response = await originalFetch(...args);

      // =========================
      // 401 - Unauthorized
      // =========================
      if (response.status === 401) {
        console.error(
          `Authentication Error ${response.status}:`,
          requestUrl
        );

        localStorage.removeItem("Token");

        window.dispatchEvent(
          new CustomEvent("api-auth-error", {
            detail: {
              status: 401,
              endpoint: requestUrl,
            },
          })
        );

        return response;
      }

      // =========================
      // 500+ - Server Error
      // =========================
      if (response.status >= 500) {
        console.error(
          `API Server Error ${response.status}:`,
          requestUrl
        );

        window.dispatchEvent(
          new CustomEvent("api-server-error", {
            detail: {
              status: response.status,
              endpoint: requestUrl,
            },
          })
        );
      }

      return response;

    } catch (error) {
      console.error("Fetch Error:", error);

      // =========================
      // Internet actually OFF
      // =========================
      if (!navigator.onLine) {
        window.dispatchEvent(
          new CustomEvent("api-network-error", {
            detail: {
              error,
              endpoint: requestUrl,
            },
          })
        );
      } else {
        // =========================
        // Internet ON
        // Backend unreachable/down
        // =========================
        window.dispatchEvent(
          new CustomEvent("api-server-error", {
            detail: {
              status: 0,
              error,
              endpoint: requestUrl,
            },
          })
        );
      }

      throw error;
    }
  };
};

export default initializeFetchInterceptor;